module.exports = __webpack_public_path__ + "static/img/evaluation-scheme.81463b56.png";